
import React from "react";
import { Routes, Route,} from "react-router-dom";
import DeliveryOrderScreen from "../screen/DeliveryOrderScreen";
import DispenseChemicalScreen from "../screen/DispenseChemicalScreen";
import LoginScreen from "../screen/LoginScreen";
import MenuScreen from "../screen/MenuScreen";
import NotFoundScreen from "../screen/NotFoundScreen";
import PondTankLabScreen from "../screen/PondTankLabSceen";
import PondTruckHistoryScreen from "../screen/PondTruckHistoryScreen";
import PrecursorChemicalScreen from "../screen/PrecursorChemicalScreen";
import ProduceOrderScreen from "../screen/ProduceOrderScreen";
import PurchaseDetailScreen from "../screen/PurchaseDetailScreen";
import PurchaseSendProductScreen from "../screen/PurchaseSendProductScreen";
import StorageTankFillScreen from "../screen/StorageTankFillScreen";
import PrivateOutlet from "./PrivateOutlet";
import PondSummaryScreen from "../screen/PondSummaryScreen";
import TankSummaryScreen from "../screen/TankSummaryScreen";
import QualityChemicalSummaryScreen from "../screen/QualityChemicalSummaryScreen";
import PureChemicalSummaryScreen from "../screen/PureChemicalSummaryScreen";
import SkimSummaryScreen from "../screen/SkimSummaryScreen";

export const PATH = {
  LOGIN: "/login",
  MAIN: "/",
  MENU: "/menu",
  RECEIVING_LATEX : "/receiving-latex",
  LAB_LATEX : "/lab-latex",
  POND_LATEX : "/pond-latex",
  STORAGE_TANK: "/storage-tank",
  STORAGE_SKIM: "/storage-skim",
  PURCHASE_FRESH : "/purchase-fresh",
  PURCHASE_CONCENTRATED: "/purchase-concentrated",
  PURCHASE_DETAIL : "/purchase-detail",
  PURCHASE_SEND_PRODUCT : "/purchase-send-product",
  PURE_CHEMICAL : "/pure-chemical",
  QUALITY_CHEMICAL : "/quality-chemical",
  DISPENSE_CHEMICAL : "/dispense-chemicals",
  POND_TRUCK_HISTORY : "/pond-truck-history",
  POND_LAB : "/pond-lab",
  SALE_LIST : '/sale-list',
  PURCHASE_RECORD : '/purchase-record',
  PRECURSOR_CHEMICAL : '/precursor-chemical',
  TRUCK_HISTORY : '/truck-history',
  LAB_LATEX_QC : '/lab-latex-qc',
  LAB_CON_QC : '/lab-con-qc',
  QC_TANK : '/qc-tank',
  POND_RECIEVE_LATEX : '/pond-recieve-latex',
  SKIM_CHEMICAL : '/skim-chemical',
  PRODUCE_PRE_ORDER : '/produce-pre-order',
  POND_SUMMARY : '/pond-summary',
  TANK_SUMMARY : '/tank-summary',
  PURE_CHEMICAL_SUMMARY : '/pure-chemical-summary',
  QUALITY_CHEMICAL_SUMMARY : '/quality-chemical-summary',
  SKIM_SUMMARY : '/skim-summary',
  MANNUAL : '/mannual',
  PAYMENT_REPORT : '/payment-report',
  USER : '/user-manage',

  //setting
  BUYER_SETTING : '/buyer-setting', 
  FACTORY_SETTING : '/factory-setting',
  POND_TANK_SETTING : '/pond-tank-setting',
  PRODUCT_TYPE_SETTING : '/product-type-setting',
  SELLER_SETTING : '/seller-setting',
  SHIPPING_SETTING : '/shipping-setting',
  STORAGE_TANK_FILL : "/storage-tank-fill",
  SALE_LIST : '/sale-list',
  PRODUCE_ORDER : '/produce-order',
  DELIVERY_ORDER : '/delivery-order',
  REPORT : '/report',

}

export default function CustomRoutes() {
  return (
    <Routes>
      <Route exact path={PATH.LOGIN} element={<LoginScreen/>} />
        <Route path={PATH.MAIN} element={<PrivateOutlet/>}>
          <Route index element={<MenuScreen />} />
          <Route exact path={PATH.MAIN} element={<MenuScreen/>} />
          <Route path='' element={<MenuScreen/>}/>
          <Route path=':menu/*' element={<MenuScreen/>}/>
          <Route path={`${PATH.PURCHASE_DETAIL}`} element={<PurchaseDetailScreen />}/>
          <Route path={`${PATH.PURCHASE_SEND_PRODUCT}`} element={<PurchaseSendProductScreen />}/>
          <Route path={`${PATH.POND_TRUCK_HISTORY}/:id`} element={<PondTruckHistoryScreen />}/>
          <Route path={`${PATH.POND_TRUCK_HISTORY}/:id/:type`} element={<PondTruckHistoryScreen />}/>
          <Route path={`${PATH.POND_LAB}/:id/:role`} element={<PondTankLabScreen />}/>
          <Route path={`${PATH.STORAGE_TANK_FILL}/:id`} element={<StorageTankFillScreen />}/>
          <Route path={`${PATH.PRODUCE_ORDER}/:type/:id`} element={<ProduceOrderScreen />}/>
          <Route path={`${PATH.DELIVERY_ORDER}/:type/:id`} element={<DeliveryOrderScreen />}/>
          <Route path={`${PATH.PRECURSOR_CHEMICAL}/:id`} element={<PrecursorChemicalScreen />}/>
          <Route path={`${PATH.DISPENSE_CHEMICAL}/:type/:id`} element={<DispenseChemicalScreen />}/>
          <Route path={`${PATH.POND_SUMMARY}/:id`} element={<PondSummaryScreen />}/>
          <Route path={`${PATH.PURE_CHEMICAL_SUMMARY}/:id`} element={<PureChemicalSummaryScreen/>}/>
          <Route path={`${PATH.QUALITY_CHEMICAL_SUMMARY}/:id`} element={<QualityChemicalSummaryScreen />}/>
          <Route path={`${PATH.TANK_SUMMARY}/:id`} element={<TankSummaryScreen />}/>
          <Route path={`${PATH.SKIM_SUMMARY}/:id`} element={<SkimSummaryScreen />}/>

        </Route>
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  )
}